module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"family\"-in-pomona-california-788d1d94b4026078bd8078e514dcfcae.png";